import { createReducer, on, Action } from '@ngrx/store';
import { ResearcherRequest } from 'src/app/models/researcher-request';
import * as researcherRequestsActions from './requests.actions';
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';

export interface ResearcherRequestState extends EntityState<ResearcherRequest> {
  loadingRequests: boolean;
  requestsLoaded: boolean;
}

export const researcherRequestAdapter: EntityAdapter<ResearcherRequest> = createEntityAdapter<ResearcherRequest>({});

export const initialResearcherRequestState: ResearcherRequestState = researcherRequestAdapter.getInitialState({
  loadingRequests: false,
  requestsLoaded: false,
});

export const reducer = createReducer(
  initialResearcherRequestState,
  on(researcherRequestsActions.getRequests, (state) => {
    return {
      ...state,
      loadingRequests: true,
      requestsLoaded: false,
    };
  }),
  on(researcherRequestsActions.getRequestsSuccess, (state, { requests }) => {
    return researcherRequestAdapter.setAll(requests, {
      ...state,
      loadingRequests: false,
      requestsLoaded: true,
    });
  }),
  on(researcherRequestsActions.getRequestsError, (state) => {
    return {
      ...state,
      loadingRequests: false,
      requestsLoaded: false,
    };
  }),
  on(researcherRequestsActions.acceptRequestSuccess, (state, { acceptedRequest }) => {
    return researcherRequestAdapter.removeOne(acceptedRequest.id, {
      ...state,
    });
  }),
  on(researcherRequestsActions.rejectRequestSuccess, (state, { rejectedRequest }) => {
    return researcherRequestAdapter.removeOne(rejectedRequest.id, {
      ...state,
    });
  })
);

export function researcherRequestReducer(state: ResearcherRequestState | undefined, action: Action) {
  return reducer(state, action);
}

export const { selectIds, selectEntities, selectAll, selectTotal } = researcherRequestAdapter.getSelectors();
